import { render, staticRenderFns } from "./ProductAccessory.vue?vue&type=template&id=1a5589be&scoped=true&"
import script from "./ProductAccessory.ts?vue&type=script&lang=js&"
export * from "./ProductAccessory.ts?vue&type=script&lang=js&"
import style0 from "./ProductAccessory.vue?vue&type=style&index=0&id=1a5589be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a5589be",
  null
  
)

export default component.exports